<template>
  <nav class="top-toolbar navbar navbar-desktop flex-nowrap bg-dark px-2">
    <ul class="site-logo d-flex align-items-center">
      <li>
        <!-- START LOGO -->
        <a @click="$goPage(userCustomization.getHomePath)">
          <!-- style="width: 90px; height: 60px" -->
          <div
            class="d-flex justify-content-center align-items-center"
            style="width: 140px; height: 60px"
          >
            <img :src="getLogo" style="width: 140px" />
          </div>
        </a>
        <!-- END LOGO -->
      </li>
    </ul>
    <!-- START LEFT DROPDOWN MENUS -->
    <ul class="navbar-nav nav-left custom-hide">
      <li
        class="nav-item nav-text px-0"
        v-for="nav in navItem"
        @click="$goPage(nav.path)"
      >
        <a :class="global.lightHeaderText === nav.tag ? 'text-primary' : ''"
          ><i
            class="icon"
            :class="[
              nav.icon,
              global.lightHeaderText === nav.tag ? 'text-primary' : '',
            ]"
          ></i
          ><span class="s-text msu-semibold">{{ nav.name }}</span></a
        >
      </li>
    </ul>
    <!-- END LEFT DROPDOWN MENUS -->
    <!-- START RIGHT TOOLBAR ICON MENUS -->
    <ul class="navbar-nav nav-right d-flex align-items-center">
      <!--  -->
      <li class="nav-item d-none d-xl-block" @click="openNotify()">
        <a
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          class="d-flex align-items-center justify-content-center"
        >
          <i class="fa-solid fa-bell"></i>
        </a>
      </li>
      <!--  -->
      <li class="nav-item dropdown dropdown-menu-lg">
        <a
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
          class="d-flex align-items-center justify-content-center"
        >
          <i class="fa-solid fa-earth-americas"></i>
        </a>
        <div class="dropdown-menu dropdown-menu-right dropdown-menu-accout">
          <!-- <a class="dropdown-item h4">現在語言: {{ locale }}</a> -->
          <div
            @click="changeLang(lang.value)"
            class="p-2 s-text msu-semibold col-12 col-sm-12 line-break line-color text-dark"
            v-for="lang in langList"
            :class="{ 'active-language': lang.value === locale }"
          >
            {{ lang.name }}
          </div>
        </div>
      </li>
      <!-- aside bar -->
      <li class="nav-item">
        <a
          @click="clickSidebarBtn()"
          class="d-flex align-items-center justify-content-center"
        >
          <i class="icon dripicons-view-apps"></i>
        </a>
      </li>

      <li class="nav-item dropdown">
        <a
          class="nav-link nav-pill user-avatar"
          data-toggle="dropdown"
          role="button"
          aria-haspopup="true"
          aria-expanded="false"
        >
          <img
            :src="$getAvatar(user.student.image, false, user.student.titlelv)"
            class="w-35 rounded-circle"
            alt=""
          />
        </a>
        <div class="dropdown-menu dropdown-menu-right dropdown-menu-accout">
          <div class="dropdown-header pb-3">
            <div class="media d-user">
              <img
                v-if="user.student"
                class="align-self-center mr-3 w-40 rounded-circle"
                :src="
                  $getAvatar(user.student.image, false, user.student.titlelv)
                "
                alt="avatar"
              />
              <span class="font-weight-bold m-text">
                {{ user.student.studentName }}
              </span>
            </div>
          </div>
          <a
            v-for="myitem in dropdownMyItem"
            @click="goDropdownItem(myitem.path)"
            class="dropdown-item font-weight-bold m-text"
            >{{ myitem.name }}</a
          >
        </div>
      </li>
    </ul>
  </nav>

  <AboutUsModalVue :contentList="aboutInfo"></AboutUsModalVue>
  <!-- <HomeSidebarRight></HomeSidebarRight> -->
</template>
<script>
$(function () {
  "use strict";

  $('[data-toggle="offcanvas"]').on("click", function () {
    $(".offcanvas-collapse").toggleClass("open");
  });

  // $(".navbar-nav>li>.nav-link").on("click", function () {
  //   $(".offcanvas-collapse").toggleClass("open");
  // });
});
</script>
<script setup>
import { computed } from "@vue/runtime-core";
import { useUserInfoStore } from "@/store/modules/userInfo";
import { ApiGetLogo } from "@/service/apis/login";
import { useGlobalStore } from "@/store/modules/global";
import { useUserCustomizationStore } from "@/store/modules/userCustomization";
import { useI18n } from "vue-i18n";
import i18n from "@/locales";
import AboutUsModalVue from "../../Modal/AboutUsModal.vue";
const user = useUserInfoStore();
const userCustomization = useUserCustomizationStore();
// import HomeSidebarRight from "@/components/HomeSidebarRight.vue";
const { locale, t } = useI18n({
  inheritLocale: true,
});
const global = useGlobalStore();
const route = useRoute();

const aboutInfo = reactive([
  {
    key: "Name",
    value: "MSU School",
  },
  { key: "URL", value: "https://mangosteems.com/" },
  { key: "Telephone", value: "+886 (02) 2571-3003" },
  {
    key: "Address",
    value:
      "8th Floor, No. 72, Section 2, Nanjing East Road, Zhongshan District, Taipei City 104",
  },
]);
const router = useRouter();
const getIns = computed(() => {
  return user.ins;
});
const device = ref("");
const $getDevice = inject("$getDevice");
const $getAvatar = inject("$getAvatar");
const goDropdownItem = (path) => {
  console.log(path);
  console.log(path.includes("\/"));
  if (path.includes("\/")) {
    if (path === "/") {
      console.log("logout");
      localStorage.clear();
      let url = `/?ins=${getIns.value}`;
      console.log(url);
      if (getIns.value !== "") {
        router.push({
          path: path,
          query: {
            ins: getIns.value,
          },
        });
      } else {
        device.value = $getDevice();
        if (device.value === "mobile" || device.value === "tablet") {
          window.location.href = `https://${
            import.meta.env.VITE_MSU_DOMAIN
          }.mangosteems.com/apiv2/landing?clean=true`;
        } else {
          router.push({
            path: path,
            query: {
              ins: "",
            },
          });
        }
      }
    } else {
      $goPage(path);
    }
  } else if (path === "about") {
    $(`#about-modal`).modal("show");
  } else if (path === "v1") {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    let token = localStorage.getItem("token");
    let v1url = `${import.meta.env.VITE_GO_V1}/mobile/ssologin?username=${
      userInfo.student.studentName
    }&stuid=${userInfo.student.stuID}&parentID=${
      userInfo.parent.parentID
    }&token=${token}`;
    console.log(v1url);
    window.location.href = v1url;
  }
};

const $goPage = inject("$goPage");
const schoolName = ref("schoolName");

// 使用 computed 屬性動態獲取導航項目
const navItem = computed(() => {
  // 優先使用客製化配置
  if (userCustomization.userGroup !== "default") {
    return userCustomization.filteredNavItems.map((item) => ({
      ...item,
      name: t(item.name), // 添加 i18n 翻譯
    }));
  }

  // 如果沒有客製化配置，使用環境變數邏輯
  if (import.meta.env.VITE_MSU_DOMAIN === "app") {
    return [
      {
        path: "/msu/home",
        name: t("home"),
        icon: "dripicons-home",
        tag: "Home",
      },
      {
        path: "/msu/homework",
        name: t("assignment"),
        icon: "dripicons-graduation",
        tag: "Assignment",
      },
      {
        path: "/msu/aispeech",
        name: "AI Speech",
        icon: "fa-solid fa-robot",
        tag: "AI Speech",
      },
      {
        path: "/msu/daily-goal/*",
        name: t("daily-task"),
        icon: "dripicons-trophy",
        tag: "Daily Task",
      },
      {
        path: "/msu/daily-login",
        name: t("login-record"),
        icon: "dripicons-calendar",
        tag: "Login Record",
      },
    ];
  } else {
    return [
      {
        path: "/msu/home",
        name: t("home"),
        icon: "dripicons-home",
        tag: "Home",
      },
      {
        path: "/msu/homework",
        name: t("assignment"),
        icon: "dripicons-graduation",
        tag: "Assignment",
      },
      {
        path: "/msu/aispeech",
        name: "AI Speech",
        icon: "fa-solid fa-robot",
        tag: "AI Speech",
      },
      {
        path: "/msu/daily-goal/*",
        name: t("daily-task"),
        icon: "dripicons-trophy",
        tag: "Daily Task",
      },
      {
        path: "/msu/daily-login",
        name: t("login-record"),
        icon: "dripicons-calendar",
        tag: "Login Record",
      },
    ];
  }
});

// 使用 computed 屬性動態獲取下拉選單項目
const dropdownMyItem = computed(() => {
  if (import.meta.env.VITE_MSU_DOMAIN === "app") {
    return [
      { path: "/msu/my-title", name: t("my-title"), icon: "dripicons-item" },
      {
        path: "/msu/my-achievement",
        name: t("my-achievement"),
        icon: "dripicons-item",
      },
      { path: "/msu/my-award", name: t("my-award"), icon: "dripicons-item" },
      {
        path: "/msu/my-dictionary",
        name: t("my-dictionary"),
        icon: "dripicons-item",
      },
      {
        path: "/msu/reading-history",
        name: t("reading-history"),
        icon: "dripicons-item",
      },
      {
        path: "/parents-login/true",
        name: t("parent-account"),
        icon: "dripicons-item",
      },
      {
        path: "about",
        name: t("about-us"),
        icon: "dripicons-item",
      },
      { path: "/", name: t("sign-out"), icon: "dripicons-item" },
    ];
  } else {
    return [
      { path: "/msu/my-title", name: t("my-title"), icon: "dripicons-item" },
      {
        path: "/msu/my-achievement",
        name: t("my-achievement"),
        icon: "dripicons-item",
      },
      { path: "/msu/my-award", name: t("my-award"), icon: "dripicons-item" },
      {
        path: "/msu/my-dictionary",
        name: t("my-dictionary"),
        icon: "dripicons-item",
      },
      {
        path: "/msu/reading-history",
        name: t("reading-history"),
        icon: "dripicons-item",
      },
      {
        path: "/parents-login/true",
        name: t("parent-account"),
        icon: "dripicons-item",
      },
      {
        path: "about",
        name: t("about-us"),
        icon: "dripicons-item",
      },
      { path: "/", name: t("sign-out"), icon: "dripicons-item" },
    ];
  }
});

// --
// const langList = ref([
//   { name: t("english"), value: "en-US" },
//   { name: t("traditional-chinese"), value: "zh-TW" },
//   { name: t("japanese"), value: "ja-JP" },
// ]);
const langList = computed(() => {
  return global.langList;
});
const changeLang = (lang) => {
  if (locale.value !== lang) {
    locale.value = lang;
    localStorage.setItem("locale", locale.value);
    window.location.reload();
  }
};

const getLogo = computed(() => {
  let result = ApiGetLogo.get();
  console.log(result);
  return result;
});
//

const $MsuAsidebar = inject("$MsuAsidebar");
const openAsidebar = () => {
  $MsuAsidebar();
  // console.log($MsuAsidebar());
  // $("#home-aside-bar").trigger("click");
};
const clickSidebarBtn = () => {
  if (global.showSidebar === false) {
    global.$patch((state) => {
      state.showSidebar = true;
    });
  } else {
    global.$patch((state) => {
      state.showSidebar = false;
    });
  }
};
const openNotify = () => {
  $(`#modal-notify`).modal("show");
};

// Make sure locale is reactive
</script>
<style lang="scss" scoped>
.dropdown-menu-lg .dropdown-menu {
  min-height: 100px !important;
}

.top-toolbar {
  height: 81px !important;
}
.top-toolbar2 {
  height: 81px !important;
}
.dropdown .dropdown-menu {
  width: 290px;
}

.active-language {
  background-color: #e6f7ff; // Light blue background for the active language
  font-weight: bold;
}

// 導航項目的hover效果
.navbar-nav .nav-item {
  position: relative;
  height: 100%; // 添加這行
  display: flex; // 添加這行
  align-items: center; // 添加這行

  a {
    transition: all 0.3s ease;
    position: relative;
    padding: 0.5rem 1rem;
    display: flex; // 添加這行
    align-items: center; // 添加這行
    gap: 0.5rem; // 添加這行，控制圖標和文字的間距

    &::after {
      content: "";
      position: absolute;
      bottom: -2px;
      left: 50%;
      width: 0;
      height: 2px;
      background-color: var(--primary); // 使用主題色
      transition: all 0.3s ease;
      transform: translateX(-50%);
    }

    &:hover {
      color: var(--primary) !important;

      &::after {
        width: 80%;
      }

      .icon {
        transform: translateY(-2px);
      }

      .s-text {
        transform: translateY(-2px);
      }
    }
  }

  .icon {
    transition: transform 0.3s ease;
    display: flex; // 添加這行
    align-items: center; // 添加這行
  }

  .s-text {
    transition: transform 0.3s ease;
    display: inline-flex; // 改為 inline-flex
    align-items: center; // 添加這行
  }
}

// 如果還需要整個導航列的對齊
.navbar-nav.nav-left {
  height: 100%; // 添加這行
  display: flex; // 添加這行
  align-items: center; // 添加這行
}

// 右側工具欄的hover效果
.nav-right {
  .nav-item {
    a {
      transition: all 0.3s ease;

      &:hover {
        i {
          transform: scale(1.1);
          color: var(--primary);
        }
      }
    }

    i {
      transition: all 0.3s ease;
    }
  }

  // 用戶頭像特殊效果
  .nav-pill.user-avatar {
    position: relative;
    overflow: hidden;

    &::before {
      content: "";
      position: absolute;
      top: -50%;
      left: -50%;
      width: 200%;
      height: 200%;
      background: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 0.1) 50%,
        rgba(255, 255, 255, 0) 100%
      );
      transform: rotate(45deg);
      transition: all 0.3s ease;
      opacity: 0;
    }

    &:hover {
      &::before {
        animation: shine 1s ease;
      }

      img {
        transform: scale(1.1);
      }
    }

    img {
      transition: transform 0.3s ease;
    }
  }
}

// 閃光動畫
@keyframes shine {
  0% {
    opacity: 0;
    transform: rotate(45deg) translateX(-100%);
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: rotate(45deg) translateX(100%);
  }
}

// Logo hover效果
.site-logo {
  a {
    transition: all 0.3s ease;

    &:hover {
      img {
        transform: scale(1.05);
        filter: brightness(1.1);
      }
    }

    img {
      transition: all 0.3s ease;
    }
  }
}

// 語言選擇器hover效果
.dropdown-menu-accout {
  .line-break {
    transition: all 0.3s ease;

    &:hover:not(.active-language) {
      background-color: #f8f9fa;
      transform: translateX(5px);
    }
  }
}

// 新增自定義斷點
@media (max-width: 1310px) {
  .custom-hide {
    display: none !important;
  }
}

// 移除側邊欄按鈕的 hover 圓形效果
.nav-item a:hover i.icon.dripicons-view-apps:after {
  display: none !important;
}

// 備用方案：針對所有包含 dripicons-view-apps 的按鈕
.nav-item a:hover i.dripicons-view-apps:after {
  display: none !important;
}

// 更通用的覆蓋：移除所有 icon 的 hover after 效果
.nav-item a:hover i.icon:after {
  display: none !important;
}

// 針對特定圖標的覆蓋
.nav-item a:hover i.dripicons-view-apps:after {
  display: none !important;
  content: none !important;
}
</style>
